export const SET_FLAG = 'flags/SET_FLAG'
export const SET_FLAG_STARTED = 'flags/SET_FLAG_STARTED'
export const SET_FLAG_SUCCESS = 'flags/SET_FLAG_SUCCESS'
export const SET_FLAG_FAILED = 'flags/SET_FLAG_FAILED'

export const CLEAR_FLAG = 'flags/CLEAR_FLAG'
export const CLEAR_FLAG_STARTED = 'flags/CLEAR_FLAG_STARTED'
export const CLEAR_FLAG_SUCCESS = 'flags/CLEAR_FLAG_SUCCESS'
export const CLEAR_FLAG_FAILED = 'flags/CLEAR_FLAG_FAILED'
